module.exports = "pegasus_template/assets/tech/email1-img12.png";